import React from "react";
import ResourceManager from "../../components/admin/ResourceManager";
import { resolveMediaUrl } from "../../lib/mediaUrl";

const PORTFOLIO_FIELDS = [
    { key: "title",     label: "Project Title", type: "text", required: true, placeholder: "e.g. Aurelia Coffee" },
    { key: "category",  label: "Category",      type: "select", required: true, options: ["Logo", "Branding", "Signage", "Packaging", "Social Media"] },
    { key: "image_url", label: "Project Image",     type: "image", required: true, helpText: "Upload an image (JPEG/PNG/WEBP up to 3 MB) or paste a public URL." },
    { key: "client",    label: "Client Name",   type: "text", placeholder: "Optional — shown on the project page" },
    { key: "industry",  label: "Industry",      type: "text", placeholder: "Optional — e.g. Restaurant, Real Estate" },
    { key: "description", label: "Case Study / Description", type: "textarea", rows: 4, placeholder: "Optional — requirement, approach and outcome. Shown on the project detail page." },
    { key: "position",  label: "Position",      type: "number", helpText: "Lower numbers appear first." },
    { key: "visible",   label: "Visibility",    type: "switch", defaultValue: true },
];

export const AdminPortfolioPage = () => (
    <ResourceManager
        resourceKey="portfolio"
        title="Portfolio Manager"
        singular="Portfolio Item"
        description="Manage projects shown on the public Portfolio page. Toggle visibility without deleting."
        endpoint="/admin/portfolio"
        fields={PORTFOLIO_FIELDS}
        renderItem={(item) => (
            <div className="flex items-center gap-4">
                <img
                    src={resolveMediaUrl(item.image_url)}
                    alt={item.title}
                    className="w-20 h-20 object-cover rounded-lg border border-white/5 flex-shrink-0 bg-[#0a0a0a]"
                    loading="lazy"
                />
                <div className="min-w-0">
                    <div className="font-inter text-[10px] uppercase tracking-[0.25em] text-gold mb-1">
                        {item.category}
                    </div>
                    <div className="font-poppins font-medium text-white truncate">{item.title}</div>
                    <div className="font-inter text-xs text-zinc-500 mt-1 truncate">{item.image_url}</div>
                </div>
            </div>
        )}
    />
);

export default AdminPortfolioPage;
